import http from "./http";

export const getTransactions = async (page: number = 1, limit: number = 10) => {
  const res = await http.get(
    `/admin/dashboard/transaction?page=${page}&limit=${limit}`,
  );
  return res.data;
};
